import { render, staticRenderFns } from "./DetailsTeam.vue?vue&type=template&id=318dad38&"
import script from "./DetailsTeam.vue?vue&type=script&lang=js&"
export * from "./DetailsTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports